import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import * as ACT from 'components/proposals/Proposal/actions'
import { EditProposalFileHtml } from './EditProposalFileHtml'

const EditProposalFileHtmlContainer = ({
  proposalId,
  content,
  fileName,
  showEditFileModal,
  toggleEditFileModal,
  templateId,
  isHtmlProposal,
  pages,
  categories,
  pageType
}) => {
  const [htmlContent, setHtmlContent] = useState(content)

  useEffect(() => {
    setHtmlContent(content)
  }, [content])

  const dispatch = useDispatch()

  const saveHtmlContent = (contentBase64, content, options) => {
    dispatch({
      type: ACT.UPDATE_PROPOSAL_HTML_REQUESTED,
      payload: {
        proposalId,
        htmlContent: contentBase64,
        templateId,
        content,
        ...(options ? { pageType: options.pageType } : {})
      }
    })
    toggleEditFileModal()
  }

  return (
    <EditProposalFileHtml
      htmlContent={htmlContent || content}
      showEditFileModal={showEditFileModal}
      toggleEditFileModal={toggleEditFileModal}
      setHtmlContent={setHtmlContent}
      saveHtmlContent={saveHtmlContent}
      fileName={fileName}
      isHtmlProposal={isHtmlProposal}
      pages={pages}
      categories={categories}
      pageType={pageType}
    />
  )
}

export default EditProposalFileHtmlContainer
